import { Pagination as UiPagination } from "@mui/material"

import { useIsMobileDevice } from "../..//hooks/useIsMobileDevice"

export function Pagination(props) {
    const {
        page,
        count,
        onChange,
    } = props

    const isMobile = useIsMobileDevice()

    return <UiPagination
        siblingCount={1}
        boundaryCount={isMobile ? 0 : 1}
        size={isMobile ? "small" : "medium"}
        page={page}
        count={count}
        showFirstButton
        showLastButton
        color="primary"
        variant="outlined"
        onChange={onChange} />
}
